import React from 'react'


const CopyRight = props => {

    return <>
    <div className="copy-right-container">
        <p>©Protospace,  WMDD 4980  - Team Uranus, Langara The College of Higher Learning</p>
    </div>
    </>
}

export default CopyRight;